// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.domestic-type-approval-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 100px;
    background-color: #fff; /* White background */
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 20px;

  }
  
  /* Left Section - Content */
  .domestic-type-approval-text {
    width: 50%; /* Take up more space for text */
    order: 1; /* Place text on the left */
    margin-top: -35px;
  }
  
  .domestic-type-approval-text h1 {
    font-size: 2em;
    color: #000;
    margin-bottom: 10px;
  }
  
  .domestic-type-approval-text h2 {
    font-size: 1.5em;
    color: #555;
    margin-top: 20px;
    margin-bottom: 10px;
  }
  
  .domestic-type-approval-text p {
    font-size: 1em;
    color: #555;
    margin-bottom: 10px;
  }
  
  .services-list {
    list-style: none;
    padding: 0;
    margin-top: 10px;
  }
  
  .services-list li {
    font-size: 0.9em;
    color: #333;
    margin-bottom: 10px;
  }
  
  /* Right Section - Image */
  .domestic-type-approval-image {
    position: relative;
    width: 85%; /* Take up less space for the image */
    height: 100%;
    order: 2; /* Place image on the right */
    margin-top:50px;
  }
  
  
  
  /* Responsive Design */
  @media (max-width: 768px) {
    .domestic-type-approval-container {
      flex-direction: column; /* Stack items for smaller screens */
      align-items: center;
      text-align: left;
      gap: 20px;
    }
  
    .domestic-type-approval-text {
      width: 170%;
      order: 1; /* Maintain order for responsive layout */
    }
  
    .domestic-type-approval-image {
      width: 100%;
      order: 2; /* Maintain order for responsive layout */
    }
  
    .services-list li {
      width: 100%;
    }
      /* Right Section - Image */
  .domestic-type-approval-image {
    position: relative;
    width: 180%; /* Take up less space for the image */
    order: 1; /* Place image on the right */
  }
  
  .services-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
  }
  /* For 1366x768 screen size */
@media (min-width: 1366px) and (max-width: 1366px) {
  .domestic-type-approval-container {
      padding: 80px; /* Adjust padding */
  }

  .domestic-type-approval-text {
      width: 55%; /* Adjust width for text section */
  }

  .domestic-type-approval-image {
      width: 37%; /* Adjust image width */
  }

  .services-list li {
      width: 48%; /* Adjust width for services list */
  }
  .services-image {
    width: 110%;
    height: auto;
    border-radius: 8px;
  }
}

/* For 1920x1080 screen size */
@media (min-width: 1920px) and (max-width: 1920px) {
  .domestic-type-approval-container {
      padding: 120px; /* Increase padding for larger screens */
  }

  .domestic-type-approval-text {
      width: 58%; /* Adjust text section width */
  }

  .domestic-type-approval-image {
      width: 38%; /* Adjust image width */
  }

  .services-list li {
      width: 40%; /* Adjust list item width */
  }
}

/* For screens between 1380px and 1919px */
@media (min-width: 1380px) and (max-width: 1919px) {
  .domestic-type-approval-container {
      padding: 100px; /* Set padding for this screen range */
  }

  .domestic-type-approval-text {
      width: 59%; /* Adjust text width */
  }

  .domestic-type-approval-image {
      width: 30%; /* Adjust image width */
  }

  .services-list li {
      width: 44%; /* Adjust list item width */
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DomesticTypeApproval/DomesticTypeApproval.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,sBAAsB,EAAE,qBAAqB;IAC7C,kBAAkB;IAClB,wCAAwC;IACxC,SAAS;;EAEX;;EAEA,2BAA2B;EAC3B;IACE,UAAU,EAAE,gCAAgC;IAC5C,QAAQ,EAAE,2BAA2B;IACrC,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA,0BAA0B;EAC1B;IACE,kBAAkB;IAClB,UAAU,EAAE,qCAAqC;IACjD,YAAY;IACZ,QAAQ,EAAE,6BAA6B;IACvC,eAAe;EACjB;;;;EAIA,sBAAsB;EACtB;IACE;MACE,sBAAsB,EAAE,oCAAoC;MAC5D,mBAAmB;MACnB,gBAAgB;MAChB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,QAAQ,EAAE,yCAAyC;IACrD;;IAEA;MACE,WAAW;MACX,QAAQ,EAAE,yCAAyC;IACrD;;IAEA;MACE,WAAW;IACb;MACE,0BAA0B;EAC9B;IACE,kBAAkB;IAClB,WAAW,EAAE,qCAAqC;IAClD,QAAQ,EAAE,6BAA6B;EACzC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;EACA,6BAA6B;AAC/B;EACE;MACI,aAAa,EAAE,mBAAmB;EACtC;;EAEA;MACI,UAAU,EAAE,kCAAkC;EAClD;;EAEA;MACI,UAAU,EAAE,uBAAuB;EACvC;;EAEA;MACI,UAAU,EAAE,mCAAmC;EACnD;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA,8BAA8B;AAC9B;EACE;MACI,cAAc,EAAE,wCAAwC;EAC5D;;EAEA;MACI,UAAU,EAAE,8BAA8B;EAC9C;;EAEA;MACI,UAAU,EAAE,uBAAuB;EACvC;;EAEA;MACI,UAAU,EAAE,2BAA2B;EAC3C;AACF;;AAEA,0CAA0C;AAC1C;EACE;MACI,cAAc,EAAE,sCAAsC;EAC1D;;EAEA;MACI,UAAU,EAAE,sBAAsB;EACtC;;EAEA;MACI,UAAU,EAAE,uBAAuB;EACvC;;EAEA;MACI,UAAU,EAAE,2BAA2B;EAC3C;AACF","sourcesContent":["/* Main container */\n.domestic-type-approval-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 100px;\n    background-color: #fff; /* White background */\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    gap: 20px;\n\n  }\n  \n  /* Left Section - Content */\n  .domestic-type-approval-text {\n    width: 50%; /* Take up more space for text */\n    order: 1; /* Place text on the left */\n    margin-top: -35px;\n  }\n  \n  .domestic-type-approval-text h1 {\n    font-size: 2em;\n    color: #000;\n    margin-bottom: 10px;\n  }\n  \n  .domestic-type-approval-text h2 {\n    font-size: 1.5em;\n    color: #555;\n    margin-top: 20px;\n    margin-bottom: 10px;\n  }\n  \n  .domestic-type-approval-text p {\n    font-size: 1em;\n    color: #555;\n    margin-bottom: 10px;\n  }\n  \n  .services-list {\n    list-style: none;\n    padding: 0;\n    margin-top: 10px;\n  }\n  \n  .services-list li {\n    font-size: 0.9em;\n    color: #333;\n    margin-bottom: 10px;\n  }\n  \n  /* Right Section - Image */\n  .domestic-type-approval-image {\n    position: relative;\n    width: 85%; /* Take up less space for the image */\n    height: 100%;\n    order: 2; /* Place image on the right */\n    margin-top:50px;\n  }\n  \n  \n  \n  /* Responsive Design */\n  @media (max-width: 768px) {\n    .domestic-type-approval-container {\n      flex-direction: column; /* Stack items for smaller screens */\n      align-items: center;\n      text-align: left;\n      gap: 20px;\n    }\n  \n    .domestic-type-approval-text {\n      width: 170%;\n      order: 1; /* Maintain order for responsive layout */\n    }\n  \n    .domestic-type-approval-image {\n      width: 100%;\n      order: 2; /* Maintain order for responsive layout */\n    }\n  \n    .services-list li {\n      width: 100%;\n    }\n      /* Right Section - Image */\n  .domestic-type-approval-image {\n    position: relative;\n    width: 180%; /* Take up less space for the image */\n    order: 1; /* Place image on the right */\n  }\n  \n  .services-image {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n  }\n  }\n  /* For 1366x768 screen size */\n@media (min-width: 1366px) and (max-width: 1366px) {\n  .domestic-type-approval-container {\n      padding: 80px; /* Adjust padding */\n  }\n\n  .domestic-type-approval-text {\n      width: 55%; /* Adjust width for text section */\n  }\n\n  .domestic-type-approval-image {\n      width: 37%; /* Adjust image width */\n  }\n\n  .services-list li {\n      width: 48%; /* Adjust width for services list */\n  }\n  .services-image {\n    width: 110%;\n    height: auto;\n    border-radius: 8px;\n  }\n}\n\n/* For 1920x1080 screen size */\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .domestic-type-approval-container {\n      padding: 120px; /* Increase padding for larger screens */\n  }\n\n  .domestic-type-approval-text {\n      width: 58%; /* Adjust text section width */\n  }\n\n  .domestic-type-approval-image {\n      width: 38%; /* Adjust image width */\n  }\n\n  .services-list li {\n      width: 40%; /* Adjust list item width */\n  }\n}\n\n/* For screens between 1380px and 1919px */\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .domestic-type-approval-container {\n      padding: 100px; /* Set padding for this screen range */\n  }\n\n  .domestic-type-approval-text {\n      width: 59%; /* Adjust text width */\n  }\n\n  .domestic-type-approval-image {\n      width: 30%; /* Adjust image width */\n  }\n\n  .services-list li {\n      width: 44%; /* Adjust list item width */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
